export default "__VITE_ASSET__BRMaUp_P__"